import { useTranslation } from 'react-i18next'
import ChartKPIA from './ChartKPIA'
import ChartKPIB from './ChartKPIB'
import ChartKPIG from './ChartKPIG'
import ChartKPIF from './ChartKPIF'
import ChartKPIE from './ChartKPIE'

const ChartView = ({ results, type, id, law }: { results: any; type: any; id: any; law: any }) => {
  const { t } = useTranslation()

  if (!results || results.length === 0) {
    return null
  }

  switch (law) {
    case 'Abs. 1 Ziff. 1 (EU Art. 9, 1. a)':
      return (
        <ChartKPIA
          value1={Number(results[0].value)}
          // value2={17.6}
          // value3={12}
          label={t(results[0].label.text)}
          height={350}
        />
      )
    case 'Abs. 1 Ziff. 2 (EU Art. 9, 1. b)':
      return <ChartKPIB results={results} />
    case 'Abs. 1 Ziff. 4 (EU Art. 9, 1. d)':
      return <ChartKPIB results={results} isMean={false} />
    case 'Abs. 1 Ziff. 3 (EU Art. 9, 1. c)':
      return (
        <ChartKPIA
          value1={Number(results[0].value)}
          label={t(results[0].label.text)}
          isMean={false}
          height={350}
        />
      )
    case 'Abs. 1 Ziff. 5 (EU Art. 9, 1. e)':
      return <ChartKPIE results={results} />
    case 'Abs. 1 Ziff. 6 (EU Art. 9, 1. f)':
      return <ChartKPIF results={[...results].reverse()} />
    case 'Abs. 1 Ziff. 7 (EU Art. 9, 1. g)':
      return <ChartKPIG results={results} />
    default:
      return null
  }
}

export default ChartView
